import { render, staticRenderFns } from "./ViewLogAttachments.vue?vue&type=template&id=6d3fe3a4&scoped=true"
import script from "./ViewLogAttachments.vue?vue&type=script&lang=js"
export * from "./ViewLogAttachments.vue?vue&type=script&lang=js"
import style0 from "./ViewLogAttachments.vue?vue&type=style&index=0&id=6d3fe3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3fe3a4",
  null
  
)

export default component.exports